<div class="modal-header border-0">
  <div class="font-xl fw-bold text-center uppercase">
    {{'auth.login' | translate}}
  </div>
</div>
<div class="modal-body">
  <form [formGroup]="userForm" novalidate>
    <div class="form-group">
      <label class="font-xl fw-bold">
        {{'common.emailAddress' | translate}}
      </label>

      <input class="form-control"
             [placeholder]="'common.email' | translate"
             [formControlName]="'email'"
             [pattern]="EMAIL_PATTERN"
             required>
    </div>
    <div class="form-group">
      <label class="font-xl fw-bold">{{'common.password' | translate}}</label>

      <input class="form-control"
             [type]="'password'"
             [placeholder]="'common.password' | translate"
             [formControlName]="'password'"
             required>
    </div>

    <ui-message class="d-block mt-3 mb-3 blue-link"
                *ngIf="error"
                [type]="'error'">
      <div [innerHTML]="error"></div>
    </ui-message>

    <div class="modal-auth-controls mb-3 d-flex align-items-center justify-content-between"
         *ngIf="!resetPasswordRequired">
      <div>
        <button class="btn btn-text-pink font-lg"
                type="button"
                (click)="onFormChange.emit(AUTH_FORMS.LOST_PASSWORD)">{{'auth.forgotPassword' | translate}}
        </button>
      </div>

      <div>
        <button class="btn btn-pink font-lg ps-5 pe-5"
                [disabled]="!userForm.valid"
                (click)="submit()">{{'auth.login' | translate}}
        </button>
      </div>
    </div>
  </form>

  <ui-message class="d-block mt-4 mb-3"
              *ngIf="resetPasswordRequired"
              [type]="'info'">
    <div class="mb-3"
         [translate]="'auth.newPlatformPasswordRecovery.message'">
      We have migrated to new platform, but we have no control over your password as they super protected and couldn't
      copy them for you.
    </div>

    <button class="btn btn-primary"
            [translate]="'auth.newPlatformPasswordRecovery.buttonText'"
            (click)="recoverPassword()">
      Recover my password
    </button>
  </ui-message>
</div>

<div class="modal-footer-login" *ngIf="!hideFooter && !resetPasswordRequired">
  <div class="font-xl fw-bold mb-3"
       [translate]="'auth.newUser'">
    NEW USER?
  </div>
  <button class="btn btn-outline-pink font-lg"
          [translate]="'auth.registerNerUser'"
          (click)="onFormChange.emit(AUTH_FORMS.REGISTER)">
    Register new user
  </button>
</div>
